import { useTypedSelector } from "../hooks";
import { DealerAccountInfoPayload } from "../slices/dealerAccountInfoSlice";

export const useNullableDealerAccountInfo = (): DealerAccountInfoPayload => {
  const state = useTypedSelector(
    ({ _dealerAccountInfo }) => _dealerAccountInfo
  );
  return state;
};
